import axiosInstance from '../axios/axios';
import { FileInfo } from '../../models/fileInfo';

export async function uploadFilesInParallel(
  files: File[],
  createdBy: string,
): Promise<{
  batchId: string;
  filePath: string;
  uploadedFiles: string[];
  failedFiles: string[];
  fileInfos: (FileInfo | undefined)[];
}> {
  const formData = new FormData();
  files.forEach(file => formData.append('files', file));
  formData.append('createdBy', createdBy);

  const response = await axiosInstance.post('api/upload-file', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120_000,
  });
  return response.data;
}

export async function uploadFileForImport(
  file: File,
  filePath: string,
): Promise<void> {
  const formData = new FormData();
  formData.append('files', file);
  formData.append('filePath', filePath);

  await axiosInstance.post('api/upload-file', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120_000,
  });
}

export const fetchFileAsBlob = async (filePath: string): Promise<Blob> => {
  const response = await axiosInstance.get('api/download-file', {
    params: { path: filePath },
    responseType: 'blob',
  });
  return new Blob([response.data], {
    type: response.headers['content-type'],
  });
};

export const downloadFile = async (filePath: string): Promise<void> => {
  const response = await axiosInstance.get('api/download-file', {
    params: { path: filePath },
    responseType: 'blob',
  });
  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  });
  const url = URL.createObjectURL(blob);
  const fileName = filePath.split('/').pop() ?? 'download';
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
